<template>
    <div id="order">
      <!--导航栏-->
      <!-- <van-nav-bar
        title="申请退款"
        left-text="返回"
        left-arrow
        :fixed="true"
        :border="true"
        @click-left="onClickLeft"
      /> -->
      <!--订单信息-->
      <van-cell>
        <span>订单编号：{{ orderNumber }}</span>
      </van-cell>
      <van-cell-group style="margin-top: 0.6rem">
        <van-cell center>
          <div>
            <div v-for="(item, index) in goods" :key="index">
              <van-card
              
                :desc="item.skuName"
                :title="item.prodName"
                :thumb="item.pic"
                :num="'数量：'+item.prodCount"
                style="margin: 10px 5px"
              >
              </van-card>
            </div>
          </div>
        </van-cell>
      </van-cell-group>
        <van-field
          readonly
          clickable
          name="picker"
          :value="className"
          label="退款方式"
          placeholder=""
          right-icon="arrow"
          @click="showClassPickers = true"
        />
        <van-popup v-model="showClassPickers" position="bottom">
          <van-picker
            show-toolbar
            :columns="columnss"
            @confirm="onClassConfirms"
            @cancel="showClassPickers = false"
          />
        </van-popup>
      <van-field
        readonly
        clickable
        name="picker"
        :value="classNames"
        label="货物状态"
        placeholder=""
        @click="showClassPickerA = true"
        right-icon="arrow"
      />
      <van-popup v-model="showClassPickerA" position="bottom">
        <van-picker
          show-toolbar
          :columns="columns"
          @confirm="onClassConfirmA"
          @cancel="showClassPickerA = false"
        />
      </van-popup>
      <van-field
        readonly
        clickable
        name="picker"
        :value="classNamess"
        label="退款原因"
        placeholder=""
        right-icon="arrow"
        @click="showClassPicker = true"
      />
      <van-popup v-model="showClassPicker" position="bottom">
        <van-picker
          show-toolbar
          :columns="colu"
          @confirm="onClassConfirm"
          @cancel="showClassPicker = false"
        />
      </van-popup>
      <!-- 允许输入数字，调起带符号的纯数字键盘 -->
      <van-field
        v-model="number"
        type="number"
        :label="activityId === 9 || activityId === 13 ? '积分' : '退款金额'"
        :placeholder="activityId === 9 || activityId === 13 ? '请输入积分' : '请输入退款金额'"
      />
      <div>
        <p style="margin: 0px; margin-left: 30%; font-size: 12px; color: #a19c9c">
          最多可退<span v-if="activityId === 9 || activityId === 13"><img src="https://img.zhujiaxian.com/2025/09/c5cc377d7c4c44f489ddc1130c867d08.png" style="width:12px;height:12px;vertical-align:middle;" /></span><span v-else>￥</span><span style="color: red;">{{ result.actualTotal.toFixed(2) }}</span><span v-if="activityId === 9 || activityId === 13">积分</span>
        </p>
      </div>
      <!-- 输入手机号，调起手机号键盘 -->
      <van-field
        v-model="tel"
        type="tel"
        label="手机号"
        placeholder="请输入手机号"
      />
      <!-- 退款说明 -->
      <van-field v-model="text" label="退款说明" placeholder="必填，最多五十字" />
      <!--商品金额、配送费-->
      <!-- <van-cell class="dspan">
        <span>订单总额：</span>
        <template #right-icon>
          <span>{{ result.actualTotal.toFixed(2) }}</span>
        </template>
      </van-cell>
      <van-cell>
        <span>运费：</span>
        <template #right-icon>
          <span>{{ result.transfee.toFixed(2) }}</span>
        </template>
      </van-cell> -->
      <van-cell style="padding-bottom: 50px;">
        <span>上传图片：</span>
        <template #right-icon>
          <van-uploader :after-read="afterRead"  v-model="fileList" />
        </template>
      </van-cell>
      <!--提交订单-->
      <van-submit-bar>
        <template #button>
          <van-button
            style="height: 30px"
            hairline
            type="primary"
            size="large"
            @click="toapply"
            >提交</van-button
          >
          <!-- <van-button>12313</van-button> -->
        </template>
      </van-submit-bar>
    </div>
  </template>
  
  <script>
  import { upload, apply,orderDetail } from "@/https/http";
  // import { getActivityIdFromRoute } from "@/utils/urlUtil";
  export default {
    name: "Order",
    data() {
      return {
        showClassPickers:false,
        showClassPickerA:false,
        showClassPicker:false,
        fileList: [],
        columnss:[
            { text: "仅退款", siteState: 1 },
            { text: "退款退货", siteState: 2 },
        ],
        // 货物状态
        columns: [
          { text: "未收到货", siteState: 0 },
          { text: "已收到货", siteState: 1 },
        ],
        colu: [
          { text: "请选择", siteState: 0 },
          { text: "未按约定时间发货", siteState: 1 },
          { text: "拍错/多拍/不喜欢", siteState: 2 },
          { text: "协商一致退款", siteState: 3 },
          { text: "快递一直未送达", siteState: 4 },
          { text: "商品破损/少件", siteState: 5 },
          { text: "商品与描述不符", siteState: 6 },
          { text: "卖家发错货", siteState: 7 },
          { text: "质量问题", siteState: 8 },
          { text: "其他", siteState: 9 },
        ],
        result: [],
        goods: [],
        status: "", //订单状态
        // 1. 地址
        address_name: "", //地址卡片类型
        address_add: "", // 收货地址
        address_tel: null, // 收货人电话
        orderNumber: "",
        // showClassPicker: false,
        classIdA: "",//退款原因
        classIdB: "",//货物状态
        classIdC: "",//退款方式
        className: "",
        classNames: "",
        classNamess: "",
        filePath:'',
        number: null,
        tel: "",
        text: "",
        goodsNum:0,
        refundType:null,
        // activityId:null
      };
    },
    created() {
      let orderNumber = this.$route.query.orderNumber;
      let refundType = this.$route.query.refundType;
      console.log(orderNumber,refundType, "orderstateid");
      this.refundType = refundType;
      this.orderNumber = orderNumber;
      // if(localStorage.getItem("refundBackData")){
      //   let refundBackData = JSON.parse(localStorage.getItem("refundBackData"))
      //   console.log(refundBackData, "refundBackData");
      //   this.orderNumber = refundBackData.orderNumber
      // }
      // let refundItem =   JSON.parse(localStorage.getItem("refundItem"))
      // console.log(refundItem);

    //       // 从路由中获取活动ID
    // const urlActivityId = getActivityIdFromRoute(this.$route);
    // // 从全局状态获取活动ID
    // const globalActivityId = this.$store.getters.getActivityId;
    
    // // 如果URL中存在活动ID，优先使用URL中的活动ID
    // if (urlActivityId) {
    //   this.activityId = urlActivityId;
    //   // 当URL中的活动ID与全局状态中的不同时，才更新全局状态
    //   if (urlActivityId !== globalActivityId) {
    //     this.$store.dispatch('updateActivityId', urlActivityId);
    //   }
    // } else if (globalActivityId) {
    //   // URL中没有活动ID，但全局状态中有，使用全局状态中的活动ID
    //   this.activityId = globalActivityId;
    // } else {
    //   // 既没有URL活动ID也没有全局活动ID时，使用默认设置
    //   this.activityId = 8;
    // }
    // console.log(this.activityId,'activityId');

      this.getRefund();
    },
    computed: {},
    mounted() {
      // 添加浏览器返回按钮监听
      window.addEventListener('popstate', this.handlePopState);
    },
    beforeDestroy() {
      // 移除监听器
      window.removeEventListener('popstate', this.handlePopState);
    },
    methods: {
      //上传图片
      afterRead(file) {
        console.log(file);
        var data = new FormData();
        data.append("file", file.file);
        upload(data).then(result=>{
            console.log(result, "result");
            let list = {
                url:result.data.resourcesUrl+result.data.filePath
            }
            this.filePath = result.data.filePath
            this.fileList.push(list)
        });
       
      },
       toapply() {
        if(this.refundType == 2){

          let refundItem =   JSON.parse(localStorage.getItem("refundItem"))

          console.log(refundItem);
          if(this.result.actualTotal < this.number){
            this.$toast('退款金额不能大于订单金额')
            return
          }
          let data = {
          applyType:this.classIdC,
          buyerDesc: this.text,
          buyerMobile: this.tel,
          buyerReason: this.classNamess,
          isReceiver: parseInt(this.classIdB),
          orderNumber: this.orderNumber,
          photoFiles: this.filePath,
          goodsNum:refundItem.prodCount,
          refundAmount: this.number,
          refundType: this.refundType,
          orderItemId:refundItem.orderItemId
        };
        apply(data).then(result=>{
          console.log(result, "result");
          this.$router.push({ path: "/afterSales"});
        });
        }else{
          // let refundItem =   JSON.parse(localStorage.getItem("refundItem"))
          // console.log(refundItem);
          if(this.result.actualTotal < this.number){
            this.$toast('退款金额不能大于订单金额')
            return
          }
          let data = {
            applyType: this.classIdC,
            buyerDesc: this.text,
            buyerMobile: this.tel,
            buyerReason: this.classNamess,
            isReceiver: parseInt(this.classIdB),
            orderNumber:  this.orderNumber,
            photoFiles: "",
            refundAmount: this.number,
            refundType: this.refundType,
          };
          apply(data).then(result=>{
            console.log(result, "result");
            this.$router.push({ path: "/afterSales"});
          });
        }
       
       
      },
      onClassConfirmA(v) {   //货物状态
        console.log(v, "onClassConfirmA");
       
        this.classIdB = v.siteState;
        console.log(this.classIdB,'this.classIdB');
        this.classNames = v.text;
        this.showClassPickerA = false;
      },
      onClassConfirm(v) { //退款原因
        console.log(v, "onClassConfirm");
        this.classIdA = v.siteState;
        this.classNamess = v.text;
        this.showClassPicker = false;
      },
      onClassConfirms(v) { // 退款方式
        console.log(v, "onClassConfirm");
        this.classIdC = v.siteState;
        this.className = v.text;
        this.showClassPickers = false;
      },
      getRefund() {
        orderDetail(this.orderNumber).then(result=>{
            console.log(result, "orderDetail");
            this.result = result.data;
            this.goods = result.data.orderItemDtos;
            //this.activityId = result.data.activityId;
            
            // 根据获取到的activityId值设置退款方式选项
            // if (this.activityId === 15) {
            //   this.columnss = [{ text: "仅退款", siteState: 1 }];
            // } else {
              this.columnss = [{ text: "仅退款", siteState: 1 }, { text: "退款退货", siteState: 2 }];
            // }
        })
        
      },
      onClickLeft() {
        // 点击左边
        this.$router.go(-1);
      },
      chooseAddress() {
        this.$router.push("/confirmOrder/myAddress");
      },
      handlePopState() {
      console.log('返回按钮被点击');
      
      // 将当前退款信息存储到 localStorage
      const refundData = {
        orderNumber: this.orderNumber
      };
      console.log(refundData, "refundData");
      localStorage.setItem('refundBackData', JSON.stringify(refundData));
    },
    },
    // beforeDestroy() {
    //   //PubSub.unsubscribe("userAddress");
    // },
 
  };
  </script>
  
  <style scoped>
  #order {
    width: 100%;
    height: 100%;
    background-color: #f5f5f5;
  }
  .pclass {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin: 0px;
  }
  .dspan {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin: 0px;
  }
  .router-slider-enter-active,
  .router-slider-leave-active {
    transition: all 0.3s;
  }
  
  .router-slider-enter,
  .router-slider-leave-active {
    transform: translate3d(2rem, 0, 0);
    opacity: 0;
  }
  
  input {
    text-align: right;
  }
  
  ::-webkit-input-placeholder {
    /* WebKit browsers */
    direction: rtl;
  }
  
  :-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    direction: rtl;
  }
  
  ::-moz-placeholder {
    /* Mozilla Firefox 19+ but I'm not sure about working */
    direction: rtl;
  }
  
  :-ms-input-placeholder {
    /* Internet Explorer 10+ */
    direction: rtl;
  }
  </style>
  